export const Logo = ({ fill }: React.SVGProps<SVGPathElement>) => (
  <g transform="translate(75.000000, 48.000000)" fill={fill} fillRule="nonzero">
    <polygon id="Path" points="0.165625 24.742268 27.49375 24.742268 27.49375 135.257732 0.165625 135.257732" />
    <polygon id="Path" points="39.0875 0 66.415625 0 66.415625 160 39.0875 160" />
    <polygon id="Path" points="78.009375 24.742268 105.3375 24.742268 105.3375 135.257732 78.009375 135.257732" />
  </g>
);
